import { Controller } from "@hotwired/stimulus"

// Long sparklines default to scrollLeft=0 (oldest dates). Recent activity is often on the right —
// scroll to the end after layout so the latest bars and labels are in view first.
export default class extends Controller {
  connect() {
    this.alignToLatest()
  }

  alignToLatest() {
    const run = () => {
      const el = this.element
      el.scrollLeft = Math.max(0, el.scrollWidth - el.clientWidth)
    }
    requestAnimationFrame(() => requestAnimationFrame(run))
    setTimeout(run, 50)
    setTimeout(run, 450)
  }
}
